var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.input.component,_vm._b({tag:"component",staticClass:"input-template",class:{wider: _vm.wider, primary: _vm.primary}},'component',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }